import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected }) => <>
  <TableCell size={'small'}><TextCell value={_.upperFirst(_.get(row, 'variant'))} /></TableCell>
  <TableCell size={'small'}><TextCell value={`**** **** **** ${_.get(row, 'card_tail')}`} /></TableCell>
  <TableCell size={'small'}><TextCell value={`${_.padStart(row?.expiry_month, 2, '0')}/${row?.expiry_year}`} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'cardholder_name')} /></TableCell>
</>

export default React.memo(Row)
